import { useEffect, useState } from "react"

import { Autoplay, Pagination } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

import AwsImage from "components/dashboard/AwsImage"

import type { Image } from "@prisma/client"
import type { Swiper as SwiperType } from "swiper"
import type { SwiperProps } from "swiper/react"

const ProductImages: React.FC<
  React.ComponentProps<typeof Swiper> &
    SwiperProps & { selectedImageId?: Image["id"]; images: Image[] }
> = ({ selectedImageId, images, ...rest }) => {
  const [swiperState, setSwiperState] = useState<SwiperType | null>(null)

  useEffect(() => {
    if (swiperState) {
      const index = images.findIndex(image => image.id === selectedImageId)
      swiperState.slideTo(index)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedImageId])

  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      grabCursor
      autoplay={{ delay: 5000 }}
      pagination={{ clickable: true }}
      onSwiper={s => setSwiperState(s)}
      {...rest}
    >
      {images.map(image => (
        <SwiperSlide key={image.id} className="!h-auto !align-self-stretch">
          <AwsImage
            image={image}
            alt={`Product image ${image.id}`}
            sizes=""
            className="w-full h-full object-cover"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default ProductImages
